import { api, buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '../service_methods';
import React, { useCallback } from 'react';
const serviceApi = buildService('/sic_codes', {
  only: ['all']
});
const sicCodeService = {
  get: function () {
    let queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return api.get(`/sic_codes?${queryParams}`);
  },
  update: (id, sic_code) => api.update(`/sic_codes/${id}`, sic_code),
  postFormData: formData => api.postFormData('/sic_codes/sic_codes_imports', formData),
  useFetchAll: setLoading => {
    const [sicCodes, setSicCodes, fetchSicCodes] = serviceMethods.useFetch({
      callback: useCallback(async params => {
        const response = await serviceApi.all(params);
        return response.sic_codes;
      }, []),
      setLoading
    });
    return [sicCodes, setSicCodes, fetchSicCodes];
  }
};
export default sicCodeService;